import React, { Component } from 'react'

export default class ErrorPermiso extends Component {
    render() {
        return (
            <div>
                <h1>Ups!!! Usted no tiene permiso para acceder a este recurso</h1>
                
            </div>
        )
    }
}
